/**
 * The name a Sales Rep value displays as. `Order.SalesRep` is free text (see the domain comment on
 * the property), so plenty of rows already hold a plain name - this only rewrites the ones that look
 * like an email address, e.g. "firstname.lastname@octopus.com" becomes "Firstname Lastname". A value
 * with no recognisable "local.local@domain" shape is returned unchanged rather than mangled.
 * @param salesRep
 */
export function salesRepDisplayName(salesRep: string): string {
  const atIndex = salesRep.indexOf("@");
  if (atIndex <= 0 || atIndex === salesRep.length - 1) {
    return salesRep;
  }

  const localPart = salesRep.slice(0, atIndex);
  const nameParts = localPart.split(".").filter((part) => part.length > 0);
  if (nameParts.length === 0) {
    return salesRep;
  }

  return nameParts.map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1).toLowerCase()}`).join(" ");
}
